import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const Slides = Loadable({
    loader: () => import(/* webpackChunkName: "Slides" */ './slides'),
    loading: () => <div />,
});
export const NormalSlides = Loadable({
    loader: () => import(/* webpackChunkName: "NormalSlides" */ './normalSlides'),
    loading: () => <div />,
});
export const BottomSlides = Loadable({
    loader: () => import(/* webpackChunkName: "BottomSlides" */ './bottomSlides'),
    loading: () => <div />,
});
export const ShareSlides = Loadable({
    loader: () => import(/* webpackChunkName: "ShareSlides" */ './shareSlides'),
    loading: () => <div />,
});
export const IndexSlides = Loadable({
    loader: () => import(/* webpackChunkName: "IndexSlides" */ './indexSlides'),
    loading: () => <div />,
});
export const UpgradeBottomSlides = Loadable({
    loader: () => import(/* webpackChunkName: "UpgradeBottomSlides" */ './upgradeBottomSlides'),
    loading: () => <div />,
});
